import { render, staticRenderFns } from "./TransferCard.vue?vue&type=template&id=3ee72cc2&scoped=true"
import script from "./TransferCard.vue?vue&type=script&lang=js"
export * from "./TransferCard.vue?vue&type=script&lang=js"
import style0 from "./TransferCard.vue?vue&type=style&index=0&id=3ee72cc2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ee72cc2",
  null
  
)

export default component.exports